import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import ContentItemList from './ContentItemList'
import StyledSideBarItem from '../StyledSideBarItem'
import { coursesQueries } from '../../graphql/queries/'
import { useLazyQuery, useQuery } from '@apollo/react-hooks'

const useStyles = makeStyles(theme => ({
    grayBackground: {
      backgroundColor: '#e4e1e2 !important'
    }
  }));

const TrailStepList = ({ content, onClose, menu, currentContent, fistTrailId, courseId }) => {
    const classes = useStyles()
    const [trailId, setTrailId] = useState('')
    let currentTrail

    content.map(trilha => {
  
      return trilha.conteudos.forEach(cont => {     
        if(cont._id === currentContent.replace('/curso/','')) {
          currentTrail = trilha._id
        }
      
      })
    })

    const { data: dataCourseProgress } = useQuery(coursesQueries.GET_COURSE_PROGRESS, {
      variables: { curso_id: courseId }
    })
    
   
    const [loadQuery, { data: dataQuery }] = useLazyQuery(coursesQueries.GET_TRAIL_CONTENT, {       
      variables: {
        trilha_id: trailId
      }
     })
 

    const dataFiltered = (dataQuery?.conteudosTrilha || []).map(content => {
      const contentId = content?._id || ''
      const allContentsFiniched = dataCourseProgress?.progressoCurso?.conteudos_concluidos || []
      const concluido = allContentsFiniched.find(content => content === contentId)
      return {
        ...content,
        concluido
      }
    })
 

     useEffect(() => {loadQuery()}, [trailId])  // eslint-disable-line
     useEffect(() => {
      if(currentTrail !== trailId) {
        setTrailId(currentTrail)
      }
    }, [currentTrail])  // eslint-disable-line

    useEffect(() => {
      if(fistTrailId !== (null || undefined || '')) {
        setTrailId(fistTrailId)
      }
    }, [fistTrailId])

    return (
      (content || []).sort((a,b) => {
        const textA = a.titulo.toUpperCase()
        const textB = b.titulo.toUpperCase()
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
    }).map((item, key) => {

      
      const handleIsSelected = (selected) => {
        if (selected) {
          (selected) ? setTrailId(item._id) : setTrailId('')
        }
      }

      return (
        <div className={classes.grayBackground}>
          <StyledSideBarItem
          label={item.titulo}
          parentIndex={menu.subItem === key ? 0 : -1}
          childrenIndex={menu.contentItem === key ? 0 : -1}
          index={key}
          backgroundColor={'#f4f3f4'}
          isSelected={(opt) => handleIsSelected(opt)}
          thisTrailId={item._id}
          currentTrailId={trailId || 'fistContent'}
          >
            {(item._id === trailId) ?
              <ContentItemList onClose={onClose} content={dataFiltered || []} courseId={currentContent}/>
            : false}
          </StyledSideBarItem>
        </div>
      )})
    )
  
}

export default TrailStepList